jQuery(function() {
    $(".radio__input").on("change", function() {
        if($(this).val() == 'otp') {
            if($("quadpay-widget").hasClass("hide")) {
                $("quadpay-widget").removeClass("hide");
            }
            if($(".catch-upfunnel[data-show]").attr('data-show') == 'hide') {
                $(".catch-upfunnel[data-show]").attr('data-show', '');
            }            
        } else if($(this).val() == 'subscription') {
            if(!$("quadpay-widget").hasClass("hide")) {
                $("quadpay-widget").addClass("hide");
            }
            if($(".catch-upfunnel[data-show]").attr('data-show') != 'hide') {
                $(".catch-upfunnel[data-show]").attr('data-show', 'hide');
            }
        }
    });
    $(".accordion-title").on('click', function() {
        var $accordion = $(this).closest('.accordion');
        $accordion.toggleClass('active');
        $accordion.find('.accordion-content').slideToggle();
    })
});


$(".container-image-ofs").slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<button class="slick-arrow slick-prev !xtop-[50%]" aria-label="Previous product"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#FFFFFF"></circle><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="3" stroke-linecap="round"></path></svg></button>',
    nextArrow: '<button class="slick-arrow slick-next !x-top[50%]" aria-label="Next product"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="#FFFFFF"></circle><path d="M21 12L13 18.5L21 25" stroke="#B6637B" stroke-width="3" stroke-linecap="round"></path></svg></button>',
    responsive: [
    {
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        }
    },
    {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }

]


  }); 